export default __webpack_public_path__ + "static/media/real-racing.1a67fc47.png";